import { render } from "./VolunteerReport.vue?vue&type=template&id=9392e0ec&scoped=true"
import script from "./VolunteerReport.vue?vue&type=script&lang=js"
export * from "./VolunteerReport.vue?vue&type=script&lang=js"

import "./VolunteerReport.vue?vue&type=style&index=0&id=9392e0ec&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9392e0ec"]])

export default __exports__